import { CloudinaryImageViewModel } from '@api/index';

import BuyingFromSeturFeature from './Item';
import { ItemsWrapper } from './styled';

export interface WhySeturItemProps {
  label: string;
  description: string;
  image: CloudinaryImageViewModel;
}

export interface Props {
  items: WhySeturItemProps[];
}

const WhyBuyingFromSeturDesktop = ({ items }: Props) => {
  return (
    <ItemsWrapper>
      {items?.map((item) => (
        <BuyingFromSeturFeature
          key={item.label}
          image={item.image}
          label={item.label}
          description={item.description}
        />
      ))}
    </ItemsWrapper>
  );
};

export default WhyBuyingFromSeturDesktop;
